import PSAlert from "./src/components/ps-alert";
import PSButton from "./src/components/ps-button";
import PSImage from "./src/components/ps-image";
import PSTable from "./src/components/ps-table";
import PSTextfield from "./src/components/ps-textfield";
import PSReportHeader from "./src/components/ps-reportheader";
import PSDialog from "./src/components/ps-dialog";
import PSSelect from "./src/components/ps-select";
import PSOverlay from "./src/components/ps-overlay";
import PSCheckbox from "./src/components/ps-checkbox";
import PSTooltip from "./src/components/ps-tooltip";
import PSDatePicker from "./src/components/ps-datepicker";
import PSSwitch from "./src/components/ps-switch";
import PSImageTooltip from "./src/components/ps-image-tooltip";
import PSToast from "./src/components/ps-toast";
import PsIconButton from "./src/components/ps-icon-button";
import PsSearchBox from "./src/components/ps-searchbox";
import PSContextMenu from "./src/components/ps-context-menu";
import PsProperties from "./src/components/ps-properties";
import PsIcon from "./src/components/ps-icon";
import PsRowCopier from "./src/components/ps-row-copier";
import PsTabs from "./src/components/ps-tabs";
import PsTab from "./src/components/ps-tab";
import PsColumn from "./src/components/ps-column";
import PsColumnGroup from "./src/components/ps-column-group";
import PsCalendar from "./src/components/ps-calendar";
import PsActions from "./src/components/ps-actions";
import PsOrbitalMenu from "./src/components/ps-orbital-menu";
import PsTimePeriodNav from "./src/components/ps-timeperiodnav";
import PsAlertPopup from "./src/components/ps-alert-popup";

export default {
    components: {
        PSAlert,
        PsActions,
        PSButton,
        PSImage,
        PSTable,
        PSTextfield,
        PSReportHeader,
        PSDialog,
        PSSelect,
        PSOverlay,
        PSCheckbox,
        PSTooltip,
        PSImageTooltip,
        PSDatePicker,
        PSSwitch,
        PSToast,
        PsIconButton,
        PsSearchBox, 
        PSContextMenu,
        PsProperties,
        PsIcon,
        PsRowCopier,
        PsTabs,
        PsTab,
        PsColumn,
        PsColumnGroup,
        PsTimePeriodNav,
        PsOrbitalMenu,
        PsCalendar,
        PsTimePeriodNav,
        PsAlertPopup
    },
    presets: [
        "@vue/app"
    ]
};
